import type { IconSvgObject } from './types';

const ReplaceIcon: IconSvgObject = [
  ["path", { d: "M3 15.5V19.5C3 20.3284 3.67157 21 4.5 21H8.5C9.32843 21 10 20.3284 10 19.5V15.5C10 14.6716 9.32843 14 8.5 14H4.5C3.67157 14 3 14.6716 3 15.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 8.5C14 9.32843 14.6716 10 15.5 10M14 4.5C14 3.67157 14.6716 3 15.5 3M19.5 3C20.3284 3 21 3.67157 21 4.5M21 8.5C21 9.32843 20.3284 10 19.5 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 7.5L6.5 10L4 7.5M6.5 9.5V5C6.5 3.89543 7.39543 3 8.5 3L10 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ReplaceIcon;
